import React, { useState } from "react";
import Spinner from "../Components/Spiner/Spinner"; // Asegúrate de ajustar la ruta
import Topbar from "../Components/Topbar/TopBar";
import Navbar from "../Components/Navbar/Navbar";
import ContactImage from "../assets/img/contact.jpg"; // Asegúrate de tener esta imagen
import Footer from "../Components/Footer/Footer";

const Contact = () => {
  const [isLoading, setIsLoading] = useState(true);

  React.useEffect(() => {
    const timer = setTimeout(() => setIsLoading(false), 1000);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div>
      <Topbar />
      <Navbar />
      <Spinner isLoading={isLoading} />
      {!isLoading && (
        <div className="container-fluid py-5 wow fadeInUp" data-wow-delay="0.1s">
          <div className="container">
            <div className="row g-5">
              {/* Sección de texto */}
              <div className="col-lg-7">
                <div className="section-title mb-4">
                  <h5 className="position-relative d-inline-block text-primary text-uppercase">
                    Contáctanos
                  </h5>
                  <h1 className="display-5 mb-0">Estamos aquí para ayudarte</h1>
                </div>
                <h4 className="text-body fst-italic mb-4">
                  ¡Agenda tu consulta o resuelve tus dudas!
                </h4>
                <p className="mb-4">
                  Si tienes preguntas sobre nuestros servicios, precios o
                  disponibilidad, no dudes en contactarnos. Nuestro equipo está
                  listo para brindarte la mejor atención y asesorarte en todo lo
                  que necesites.
                </p>
                <div className="row g-3">
                  <div className="col-sm-6 wow zoomIn" data-wow-delay="0.3s">
                    <h5 className="mb-3">
                      <i className="fa fa-phone text-primary me-3"></i>Teléfono: +54 381 561-5279
                    </h5>
                    <h5 className="mb-3">
                      <i className="fa fa-envelope text-primary me-3"></i>Email: odontologialash@gmail.com
                    </h5>
                  </div>
                  <div className="col-sm-6 wow zoomIn" data-wow-delay="0.6s">
                    <h5 className="mb-3">
                      <i className="fa fa-map-marker text-primary me-3"></i>Ubicación: Galería Moreno (Moreno esquina Salas y Valdez) Planta alta, Local 14, Yerba Buena
                    </h5>
                    <h5 className="mb-3">
                      <i className="fa fa-clock text-primary me-3"></i>Horario: Lun - Vie: 8:00 AM - 11:30 PM , 15:30 PM - 19:00 PM
                    </h5>
                  </div>
                </div>
                <a
                  href="https://wa.me/5491112345678"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn btn-primary py-3 px-5 mt-4 wow zoomIn"
                  data-wow-delay="0.6s"
                >
                  Contáctanos por WhatsApp
                </a>
              </div>

              {/* Sección de imagen */}
              <div className="col-lg-5" style={{ minHeight: "500px" }}>
                <div className="position-relative h-100">
                  <img
                    className="position-absolute w-100 h-100 rounded wow zoomIn"
                    data-wow-delay="0.9s"
                    src={ContactImage}
                    alt="Contáctanos"
                    style={{ objectFit: "cover" }}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      <Footer/>
    </div>
  );
};

export default Contact;